import store_consultation from '@/store/mods/consultations/consultations'
import store_finance from '@/store/mods/finances/finance.js'
import $ from 'jquery'

export default {
    name: 'manage-edit-protocole',
    components: {},
    props: {
        edit_toggler: Number,
        evolution_id: Number,
        consultation_id: Number,
        data_type: String,
        model_facturation_acte: {
            type: String,
            default: () => { return '' }
        },
        editing_medicament: {
            type: Object,
            default: () => {}
        },
        editing_consommable: {
            type: Object,
            default: () => {}
        },
        editing_acte: {
            type: Object,
            default: () => {}
        },
        editing_protocole_a_suivre: {
            type: Array,
            default: () => []
        },
        user_info: Object,
        info_patient: {
            type: Object,
            default: () => {}
        },
        info_caissier: {
            type: Object,
            default: () => {}
        },
        historique_modifications: [],
        label_historique: {
            type: String,
            default: () => ''
        },
        data_to_be_deleted: {
            type: Object,
            default: () => {}
        },
        info_assurance_patient: {
            type: Object, 
            default: () => {}
        }
    },
    data() {
        return {
            prot_data: {
                qty: '',
                mode_administration: '',
                pharmacie: '',
                hn: []
            },
            prot_a_suivre: [],
            save_loading: false,
            is_error: false,
            one_is_empty: false,
            modal_title: '',
            editing_label: '',
            hn_conflict: false,
            original_qty: 0,
            curr_total_qty: 0,
            is_paid: 0,
            is_increase: "1",
            editing_item: {},
            decrese_is_greater: false,
            qty_is_empty: false,
            del_loading: false,
            is_confirm: false,
            err_msg: ''
        }
    },

    watch: {
        edit_toggler() {
            this.is_increase = "1"
            this.listeSourcePharmacie()

            if (this.data_type === 'medicament') {
                this.modal_title = 'Éditer médicament'
                this.editing_label = this.editing_medicament.medicament
                this.original_qty = parseInt(this.editing_medicament.qte)       
                this.curr_total_qty = parseInt(this.editing_medicament.qte)       
                this.is_paid = this.editing_medicament.is_paid
                this.editing_item = this.editing_medicament
                this.autoFillFieldsMedicament()
            } else if (this.data_type === 'consommable') {
                this.modal_title = 'Éditer consommable'
                this.editing_label = this.editing_consommable.consommable
                this.original_qty = parseInt(this.editing_consommable.qte)
                this.curr_total_qty = parseInt(this.editing_consommable.qte)
                this.is_paid = this.editing_consommable.is_paid
                this.editing_item = this.editing_consommable
                this.autoFillFieldsConsommable()
            } else if (this.data_type === 'acte') {
                this.modal_title = 'Éditer acte'
                this.editing_label = this.editing_acte.acte
                this.original_qty = parseInt(this.editing_acte.qte)
                this.curr_total_qty = parseInt(this.editing_acte.qte)
                this.is_paid = this.editing_acte.is_paid
                this.editing_item = this.editing_acte
                this.autoFillFieldsActe()
            }
        },

        is_increase() {
            this.clearError()
            this.calcQteTotal()
        }
    },

    computed: {
        liste_mode_administration() {
            return this.$store.getters['liste_mode_administration'];
        },

        tarif_actes() {
            return this.$store.getters["tarif_actes"];
        },

        liste_type_mix_datas() {
            return this.$store.getters["liste_type_mix_datas"];
        }
    },

    mounted() {
        this.patient_id = this.$route.params.id
    },

    methods: {
        clearError() {
            this.one_is_empty = false
            this.decrese_is_greater = false
            this.qty_is_empty = false

            const qty_err = document.getElementById("iqty"+this.evolution_id)
            if (qty_err) {
                qty_err.classList.remove("input-danger")
            }
        },

        autoFillFieldsMedicament() {
            this.prot_a_suivre = []
            this.prot_data.qty = (this.editing_medicament.is_paid == 0) ? this.editing_medicament.qte : ''

            const mode_administration = this.liste_mode_administration.filter(mode => mode.designation === this.editing_medicament.mode_administration);
            this.prot_data.mode_administration = mode_administration[0]

            const source = this.liste_type_mix_datas.filter(source => source.champ === this.editing_medicament.source);
            this.prot_data.pharmacie = source[0]

            const tmp_suivis = JSON.parse(JSON.stringify(this.editing_protocole_a_suivre));
            // Marquer les lignes en soin immediat (Rea/Bloc) : hn NULL en base
            tmp_suivis.forEach(p => {
                p.immediat = (p.protocole_hn === null || p.protocole_hn === '')
            });
            this.prot_a_suivre = tmp_suivis;
        },

        autoFillFieldsConsommable() {
            this.prot_data.qty = (this.editing_consommable.is_paid == 0) ? this.editing_consommable.qte : ''

            const source = this.liste_type_mix_datas.filter(source => source.champ === this.editing_consommable.source);
            this.prot_data.pharmacie = source[0]
        },

        autoFillFieldsActe() {
            this.prot_data.qty = (this.editing_acte.is_paid == 0) ? this.editing_acte.qte : ''
        },

        calcQteTotal() {
            let entry_qty = this.transformToNumber(this.prot_data.qty)

            // make a copy of original_qty to tmp_qty to avoid modifying it
            this.curr_total_qty = this.original_qty
            if (isNaN(entry_qty) || entry_qty < 0) {
                entry_qty = 0
                this.curr_total_qty = this.original_qty
            }
            
            if (this.is_increase === "0") {
                // Decrease
                if (entry_qty > this.editing_item.qte_ajoutee) {
                    this.decrese_is_greater = true
                    const qty_err = document.getElementById("iqty"+this.evolution_id)
                    if (qty_err) {
                        qty_err.classList.add("input-danger")
                    }
                    return
                }
                this.curr_total_qty -= entry_qty
            } else {
                // Increase
                this.curr_total_qty += entry_qty
            }
            
        },

        listeSourcePharmacie() {
            this.$store.dispatch('getListeTypeMixData', 'source_pharmacie')
        },

        addHn() {
            this.one_is_empty = false
            this.prot_a_suivre.forEach(prot => {
                if (!prot.immediat && prot.protocole_hn === '') {
                    this.one_is_empty = true
                }
            });
            if (this.one_is_empty) {
                return
            }

            const last_dosage = this.prot_a_suivre[this.prot_a_suivre.length-1].dosage
            this.prot_a_suivre.push(
                {
                    protocole_hn: '',
                    dosage: last_dosage,
                    immediat: false
                }
            )
        },

        /**
         * Bascule une ligne en soin immediat (Rea/Bloc) : hn NULL, a faire maintenant
         * @param number index
         */
        toggleImmediat(index) {
            const prot = this.prot_a_suivre[index]
            if (!prot) return
            this.$set(prot, 'immediat', !prot.immediat)
            if (prot.immediat) {
                prot.protocole_hn = null
            } else {
                prot.protocole_hn = ''
            }
            this.clearProtHnError(this.evolution_id)
        },

        medicamentDataSetter() {
            const data = {
                constitution_protocole_id: this.editing_medicament.constitution_protocole_id,
                uid: this.editing_medicament.uid,
                prestation_id: this.editing_medicament.prestation_id,
                protocole_id: this.editing_medicament.protocole_id,
                evolution_id: this.evolution_id,
                consultation_id: this.consultation_id,
                libelle: this.editing_medicament.medicament,
                qte: this.prot_data.qty,
                prix: this.editing_medicament.pu,
                mode_administration: this.prot_data.mode_administration,
                source: this.prot_data.pharmacie,
                protocole_a_suivre: this.prot_a_suivre,
                user_info: this.user_info,
                user: {
                    nom_medecin: this.user_info.user,
                    titre: this.user_info.titre,
                },
                user_id: this.user_info.id,
                can_set_pac: this.can_set_pac,
                patient_id: this.patient_id,
                info_patient: this.info_patient,
                info_caissier: this.info_caissier,
                data_type: this.data_type,
                type_prestation: 'Médicaments'
            }
            return data
        },

        consommableDataSetter() {
            const data = {
                constitution_protocole_id: this.editing_consommable.constitution_protocole_id,
                uid: this.editing_consommable.uid,
                prestation_id: this.editing_consommable.prestation_id,
                protocole_id: this.editing_consommable.protocole_id,
                evolution_id: this.evolution_id,
                consultation_id: this.consultation_id,
                libelle: this.editing_consommable.consommable,
                qte: this.prot_data.qty,
                prix: this.editing_consommable.pu,
                source: this.prot_data.pharmacie,
                user_info: this.user_info,
                user: {
                    nom_medecin: this.user_info.user,
                    titre: this.user_info.titre,
                },
                user_id: this.user_info.id,
                can_set_pac: this.can_set_pac,
                patient_id: this.patient_id,
                info_patient: this.info_patient,
                info_caissier: this.info_caissier,
                data_type: this.data_type,
                type_prestation: 'Consommables'
            }
            return data
        },

        acteDataSetter() {
            const data = {
                constitution_protocole_id: this.editing_acte.constitution_protocole_id,
                uid: this.editing_acte.uid,
                prestation_id: this.editing_acte.prestation_id,
                protocole_id: this.editing_acte.protocole_id,
                evolution_id: this.evolution_id,
                consultation_id: this.consultation_id,
                libelle: this.editing_acte.acte,
                qte: this.prot_data.qty,
                prix: this.editing_acte.pu,
                user_info: this.user_info,
                user: {
                    nom_medecin: this.user_info.user,
                    titre: this.user_info.titre,
                },
                user_id: this.user_info.id,
                can_set_pac: this.can_set_pac,
                patient_id: this.patient_id,
                info_patient: this.info_patient,
                info_caissier: this.info_caissier,
                data_type: this.data_type,
                type_prestation: 'Actes'
            }
            return data
        },

        handleHnConflict() {
            let is_conflict = false

            // check if hn are distinct (les lignes immediates hn NULL sont ignorees)
            const hn_list = this.prot_a_suivre.map((prot, i) => prot.immediat ? ('immediat_'+i) : parseInt(prot.protocole_hn))
            const distinct_hn = [...new Set(hn_list)]

            if (hn_list.length !== distinct_hn.length) {
                this.hn_conflict = true
                is_conflict = true

                // Highlight input(s) with conflict
                const _set = new Set()
                hn_list.forEach((hn, index) => {
                    if (hn_list.indexOf(hn) !== index) {
                        _set.add(hn)
                    }
                });

                // Loop through hn_list and highlight inputs
                hn_list.forEach((hn, index) => {
                    if (_set.has(hn)) {
                        const hn_err = document.getElementById("hn-"+this.evolution_id+index)
                        if (hn_err) {
                            hn_err.classList.add("input-danger")
                        }
                    }
                });
            } else {
                this.hn_conflict = false
            }
            
            return is_conflict
        },

        clearProtHnError(evolution_id) {
            this.hn_conflict = false
            // Loop on all hn inputs and remove error class
            this.prot_a_suivre.forEach((hn, index) => {
                const hn_err = document.getElementById("hn-"+evolution_id+index)
                if (hn_err) {
                    hn_err.classList.remove("input-danger")
                }
            });
        },

        save() {
            let data = {}
            if (this.data_type === 'medicament') {
                data = this.medicamentDataSetter()
            } else if (this.data_type === 'consommable') {
                data = this.consommableDataSetter()
            } else if (this.data_type === 'acte') {
                data = this.acteDataSetter()
            }
            data.model_facturation_acte = (this.model_facturation_acte != null)?this.model_facturation_acte:''
            data.is_increase = parseInt(this.is_increase)

            if (this.handleHnConflict()) {
                return
            }

            if(this.prot_data.qty === '' || this.prot_data.qty <= 0) {
                this.qty_is_empty = true
                return
            }

            if (this.decrese_is_greater) {
                return
            }

            this.save_loading = true
            store_consultation.editProtocoleData(data).then((response) => {
                if (response.success) {
                    this.$refs.edit_prot_mdl.click()
                    this.successToast(response.message)
                    this.$emit('emitProtocoleSoins')

                    if (response.action == 'store') {
                        const op_data = {
                            ...response.data,
                            duree_forfait_hospi_est_expire: this.info_assurance_patient.duree_forfait_hospi_est_expire
                        }
                        store_finance.storeLigneOperation(op_data).then((finance_response) => {
                            if (!finance_response.success) {
                                this.errorToast(finance_response.message)
                                return;
                            } 
                            // this.successToast(finance_response.message)
                        }).catch(() => {
                            this.errorToast("Une erreur s'est produite lors de l'enregistrement à la caisse")
                        })
                    } else if (response.action == 'delete') {
                        store_finance.removeItemFromCaisse(response.data).then((finance_response) => {
                            if (!finance_response.success) {
                                this.errorToast(finance_response.message)
                                return;
                            } 
                        }).catch(() => {
                            this.errorToast("Une erreur s'est produite lors de l'enregistrement à la caisse")
                        })
                    }
                } else {
                    console.log("ERROR:: ",response.message);
                }

                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.is_error = true
            })
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        deleteItem(selector) {
            let confirm = document.getElementById(selector);

            if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé la suppression
                $('.err-msg').fadeIn(500)
                return
            }

            this.del_loading = true
            const data = {
                data_id: this.data_to_be_deleted.id,
                constitution_protocole_id: this.data_to_be_deleted.constitution_protocole_id,
                data_type: this.data_to_be_deleted.data_type,
                protocole_id: this.data_to_be_deleted.protocole_id,
                user_id: this.user_info.id,
                consultation_id: this.consultation_id,
                evolution_id: this.evolution_id,
            }

            store_consultation.deleteProtocoleItem(data).then((response) => {
                if (response.success) {
                    this.successToast('Suppression effectuée avec succès !')
                    this.$emit("emitProtocoleSoins")

                    this.$refs.del_prot_item.click()

                    store_finance.removeItemFromCaisse(response.data).then((finance_response) => {
                        if (!finance_response.success) {
                            this.errorToast(finance_response.message)
                            return;
                        } 
                    }).catch(() => {
                        this.errorToast("Une erreur s'est produite lors de l'enregistrement à la caisse")
                    })
                } else {
                    this.err_msg = response.message
                }
                
                this.del_loading = false;
                this.is_confirm = false
            }).catch(() => {
                this.del_loading = false
                this.err_msg = "Une erreur s'est produite"
            })
        }
    }
}